import { environment } from 'environments/environment';

export class Jwt {
  token: string;

  aud: string[];

  azp: string;

  exp: Date;

  email: string;

  iat: Date;

  iss: string;

  scope: string;

  sub: string;

  constructor(jwt: any) {
    const jwtData = jwt.split('.')[1];
    const decodedJwtJsonData = window.atob(jwtData);
    const decodedJwtData = JSON.parse(decodedJwtJsonData);

    this.token = jwt;
    this.aud = decodedJwtData.aud;
    this.azp = decodedJwtData.azp;
    this.exp = decodedJwtData.exp;
    this.email = decodedJwtData[environment.auth.AUDIENCE + '/email'];
    this.iat = decodedJwtData.iat;
    this.iss = decodedJwtData.iss;
    this.scope = decodedJwtData.scope;
    this.sub = decodedJwtData.sub;
  }
}
